import { PackageName, Product, RawApiResponse } from './types';

export const mockApiResponse: RawApiResponse = {
    packageName: PackageName.ESSENTIALS,
    products: [
        {
            product: Product.ENGAGE,
            userHasAccess: false,
        },
        {
            product: Product.PUBLISH,
            userHasAccess: true,
        },
        {
            product: Product.CONSUMER_RESEARCH,
            userHasAccess: true,
        },
        {
            product: Product.BI_ADMIN,
            userHasAccess: false,
        },
        {
            product: Product.ADVERTISE,
            userHasAccess: false,
        },
        {
            product: Product.MEASURE,
            userHasAccess: false,
        },
        {
            product: Product.AUDIENCE,
            userHasAccess: false,
        },
        {
            product: Product.LISTEN,
            userHasAccess: false,
        },
        {
            product: Product.BENCHMARK,
            userHasAccess: false,
        },
        {
            product: Product.INFLUENCE,
            userHasAccess: false,
        },
        {
            product: Product.VIZIA,
            userHasAccess: false,
        },
    ],
};
